import React from 'react';
import '../styles/AddButton.css';

interface AddButtonProps {
  onClick: () => void;
  label?: string;
  icon?: string;
}

const AddButton: React.FC<AddButtonProps> = ({ 
  onClick, 
  label = "+ Add New Lead",
  icon 
}) => {
  return (
    <button className="add-button" onClick={onClick}>
  
      <span className="add-button-text">{label}</span>
    </button>
  );
};

export default AddButton;